import {extraProfileData2Object} from 'common-data-handling';
import {memoize} from 'lodash';

/**
 * Converts categories list to filter params (memoized for reference comparison)
 * @param {Array} categoriesList
 * @returns {object}
 */
export const categoriesList2FilterParams = memoize(categoriesList => {
    return {
        categories: extraProfileData2Object(categoriesList),
    };
});
